
<div>

  <div class="modal-header light-blue-header white">
    <div class="modal-title">
        <h5>
            Customize Test Parameters
        </h5>
    </div>
    <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="cancel()"
    >
        <span aria-hidden="true">&times;</span>
    </button>
  </div>


  <div class="modal-body">
    <app-volunteer-task-point-test-params #paramsComponent
    [config]="config" [taskPoint]="taskPoint" [bFormMode]="true">

  </app-volunteer-task-point-test-params>
  </div>

  <div class="modal-footer">
    <div class="d-flex flex-row justify-content-end">
      <button class="btn btn-primary mr-3" 
          [disabled]="bSaving"
          (click)="save()">          
        <i *ngIf="bSaving" class="fa fa-spinner fa-spin mr-2"></i>Save
      </button>
      <button class="btn btn-warning" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>

